import { AfterViewInit, Directive, ElementRef, OnDestroy, PLATFORM_ID, inject, input } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

// Fades/slides the host up into place the first time it scrolls into view; delay lets a list reveal in sequence.
@Directive({
    selector: '[appRevealOnScroll]',
    standalone: true,
    host: { class: 'reveal-on-scroll' }
})
export class RevealOnScrollDirective implements AfterViewInit, OnDestroy {
    readonly revealDelay = input<number>(0, { alias: 'appRevealOnScroll' });

    private readonly elementRef = inject(ElementRef<HTMLElement>);
    private readonly platformId = inject(PLATFORM_ID);
    private observer?: IntersectionObserver;

    ngAfterViewInit(): void {
        const element = this.elementRef.nativeElement;
        element.style.transitionDelay = `${this.revealDelay()}ms`;

        if (!isPlatformBrowser(this.platformId) || typeof IntersectionObserver === 'undefined') {
            element.classList.add('reveal-visible');
            return;
        }

        this.observer = new IntersectionObserver(
            (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        element.classList.add('reveal-visible');
                        this.observer?.unobserve(element);
                    }
                }
            },
            { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
        );
        this.observer.observe(element);
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }
}
